import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    itemlist: [],
    selectedItemId: '',
    savedCategoryId: '',
    markdownGather: {},
    orderGather: {},
    orderGatherSku: [],
    predictGather: {},

    downloadState: true,

    // カテゴリID「全て」はAPI問い合わせ時は空白とする
    conCategoryId_: id => id === '00' ? '' : id
  },

  getters: {
    itemlist(state) {
      return state.itemlist
    },
    selectedItemId(state) {
      return state.selectedItemId
    },
    savedCategoryId(state) {
      return state.savedCategoryId
    },
    markdownGather(state) {
      return state.markdownGather
    },
    orderGather(state) {
      return state.orderGather
    },
    orderGatherSku(state) {
      return state.orderGatherSku
    },
    downloadState(state) {
      return state.downloadState
    }
  },

  mutations: {
    itemlist(state, payload) {
      state.itemlist = payload
    },
    selectedItemId(state, payload) {
      state.selectedItemId = payload
    },
    savedCategoryId(state, payload) {
      state.savedCategoryId = payload
    },
    markdownGather(state, payload) {
      state.markdownGather = payload
    },
    orderGather(state, payload) {
      state.orderGather = payload
    },
    orderGatherSku(state, payload) {
      state.orderGatherSku = payload
    },
    downloadState(state, payload) {
      state.downloadState = payload
    },
    resetItemlist(state) {
      state.itemlist = []
      state.selectedItemId = ''
      state.savedCategoryId = ''
    }
  },

  actions: {
    /**
     * item一覧取得
     * 選択したカテゴリIDも保存しておく
     */
    getItemlist({ commit, state }, payload) {
      commit('selectedItemId', '')
      commit('savedCategoryId', payload.categoryId)

      const data = {
        category_id: state.conCategoryId_(payload.categoryId)
      }

      api.get('/api/v2/itemlist/get', data)
        .then((res) => {
          commit('itemlist', res.data.itemlist)
        })
    },

    /**
     * 選択したitemIDを保存
     */
    setSelectedItemId({ commit }, payload) {
      commit('selectedItemId', payload)
    },

    /**
     * 予測やマークダウンサジェスト結果をまとめたitem一覧取得
     */
    getMarkdownGatherItemlist({ commit, state }, payload) {
      commit('downloadState', false)

      const data = {
        itemlist: payload.itemlist
      }

      return api.post('/api/v2/itemlist/markdown/gather/get', data)
        .then((res) => {
          commit('markdownGather', res.data.markdown_gather)
        })
        .finally(() => {
          commit('downloadState', true)
        })
    },

    /**
     * 予測や追加発注サジェスト結果をまとめたitem一覧(品番)取得
     */
    getOrderGatherItemlist({ commit, state }, payload) {
      commit('downloadState', false)

      const data = {
        itemlist: payload.itemlist
      }

      return api.post('/api/v2/itemlist/order/gather/get', data)
        .then((res) => {
          commit('orderGather', res.data.order_gather)
        })
        .finally(() => {
          commit('downloadState', true)
        })
    },

    /**
     * 予測や追加発注サジェスト結果をまとめたitem一覧(SKU)取得
     */
    getOrderGatherSkulist({ commit, state }, payload) {
      commit('downloadState', false)

      const data = {
        itemlist: payload.itemlist
      }

      return api.post('/api/v2/itemlist/order/gather/sku/get', data)
        .then((res) => {
          commit('orderGatherSku', res.data.order_gather)
        })
        .finally(() => {
          commit('downloadState', true)
        })
    },

    /**
     * 日別ログダウンロード
     */
    getPredictLogDownload({ commit, state }, payload) {
      commit('downloadState', false)
      const data = {
        suggest_type: payload.suggest_type
      }
      return api.post('/api/v2/predictlog/download', data)
        .finally(() => {
          commit('downloadState', true)
        })
    },

    /**
     * Sale対応マークダウンCSVダウンロード
     */
    getSaleMarkDownCSVDownload({ commit }) {
      commit('downloadState', false)

      // user_idを入れる為の空の{}を用意
      return api.post('/api/v2/sale/markdown/download', {})
        .finally(() => {
          commit('downloadState', true)
        })
    },

    /**
     * 週別マークダウンCSVダウンロード
     */
    getWeeklyMarkDownCSVDownload({ commit }) {
      commit('downloadState', false)

      // user_idを入れる為の空の{}を用意
      return api.post('/api/v2/thisweek/markdown/download', {})
        .finally(() => {
          commit('downloadState', true)
        })
    },

    /**
     * ログアウト時にitem一覧をリセットする
     */
    resetItemlist({ commit }) {
      commit('resetItemlist')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/itemlist.js